import React, { Component } from 'react';
import { Modal } from 'antd';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { cancel } = this.props;
    return (
      <Modal
        title="提示"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.props.handSubmit}
        maskClosable={false}
      >
        <p>确认对所选发票进行该操作吗？</p>
      </Modal>
    );
  }
}
export default Index;



// WEBPACK FOOTER //
// ./src/components/xianxing/invoice/ModalTip.js